import { Link } from 'react-router-dom';

const OnboardingFailed = () => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-min-h-screen tw-bg-red-50 tw-p-6">
      <div className="tw-bg-white tw-rounded-xl tw-shadow-md tw-p-8 tw-text-center tw-max-w-md">
        <svg
          className="tw-w-12 tw-h-12 tw-text-red-500 tw-mx-auto"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
        <h1 className="tw-text-2xl tw-font-semibold tw-mt-4">Onboarding Failed</h1>
        <p className="tw-text-gray-600 tw-mt-2">
          Something went wrong during your onboarding. Please try again or contact support.
        </p>
        <Link
          to="/contactUs"
          className="tw-inline-block tw-mt-6 tw-bg-red-500 tw-text-white tw-px-4 tw-py-2 tw-rounded hover:tw-bg-red-600"
        >
          Contact Support
        </Link>
      </div>
    </div>
  );
};

export default OnboardingFailed;
